// @flow
import React, { useState } from "react";
import {
    Typography,
    Box,
    withStyles,
    CircularProgress,
    Button,
    FormHelperText,
} from "@material-ui/core";
import { Field, reduxForm } from "redux-form";
import { compose } from "redux";
import { connect } from "react-redux";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import validate from "../utils/validate";
import RFInputField from "../components/RFInputField";
import RFCheckbox from "../components/RFCheckbox";
import styles from "../styles/styles";

type Props = {
    handleSubmit: Function,
    classes: Object,
    error: any,
    errors: Object[],
    loading: boolean,
    created: string,
    reset: Function,
    previousPage: Function,
    valid: boolean,
};

const ThirdPage = (props: Props) => {
    const {
        handleSubmit,
        classes,
        error,
        loading,
        created,
        reset,
        previousPage,
        errors,
        valid,
    } = props;
    const [showAdress, setShowAddress] = useState(false);

    if (created) {
        reset("event");
    }

    const onShowAddressChange = event => {
        const { value } = event.target;

        if (value === "oui") {
            setShowAddress(true);
        } else {
            setShowAddress(false);
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit} method="POST" id="form_page_3">
                <Box>
                    <Typography variant="h3" className="main__title">
                        Kit de communication
                    </Typography>
                    <Typography variant="body1" className="indication">
                        {`Si vous souhaitez recevoir un kit de communication gratuit, vous devez désormais nous le notifier 
                            en répondant à la question qui suit. Cette année, nous avons conçu deux affiches, les animations se déroulant dans un
                            moulin recevront une affiche spécifique, illustrant ce patrimoine.`}
                    </Typography>
                    <Typography
                        variant=" "
                        className={[classes.spacingUp, "form__title"].join(" ")}
                    >
                        {
                            "Souhaitez-vous recevoir un kit de communication gratuit"
                        }
                    </Typography>
                    <Box>
                        <RadioGroup
                            aria-labelledby="radio-buttons-group-label"
                            defaultValue="non"
                            name="radio-buttons-group"
                            onChange={onShowAddressChange}
                            row
                        >
                            <FormControlLabel
                                value="oui"
                                control={<Radio className="form__radio" />}
                                label="Oui"
                            />
                            <FormControlLabel
                                value="non"
                                control={<Radio className="form__radio" />}
                                label="Non"
                            />
                        </RadioGroup>
                    </Box>
                    <Typography variant="caption">
                        {
                            "Merci de nous indiquer l'adresse postale (si différente) à laquelle vous souhaitez recevoir ce kit"
                        }
                    </Typography>
                    {showAdress && (
                        <>
                            <Field
                                name="shippingName"
                                component={RFInputField}
                                label="Nom et prénom ou structure responsable de l’animation"
                                type="text"
                            />
                            <Field
                                name="shippingAddress"
                                component={RFInputField}
                                label="Adresse"
                                type="text"
                            />
                            <Field
                                name="shippingAddressAdditional"
                                component={RFInputField}
                                label="Adresse 2"
                                type="text"
                            />
                            <Field
                                name="shippingPostalCode"
                                component={RFInputField}
                                label="Code postal"
                                type="text"
                            />
                            <Field
                                name="shippingCity"
                                component={RFInputField}
                                label="Ville"
                                type="text"
                            />
                        </>
                    )}
                </Box>
                <Box>
                    <Typography
                        variant=" "
                        className={[classes.spacingUp, "form__title"].join(" ")}
                    >
                        Kits supplémentaires
                    </Typography>
                    <br />
                    <Typography variant="caption">
                        Vous pouvez imprimer ou acquérir des visuels
                        supplémentaires :
                    </Typography>
                    <div className="ddl-button">
                        <Button
                            type="button"
                            className="form__button"
                            onClick={() => {
                                window.open(
                                    "https://www.patrimoinedepays-moulins.org/kit-presse",
                                    "_blank"
                                );
                            }}
                        >
                            Télécharger pour impression
                        </Button>
                        <Button
                            type="button"
                            className="form__button"
                            onClick={() => {
                                window.open(
                                    "https://www.helloasso.com/associations/patrimoine-environnement/boutiques/la-boutique-patrimoine-environnement",
                                    "_blank"
                                );
                            }}
                        >
                            Acquérir des kits de communication supplémentaires
                        </Button>
                    </div>
                </Box>
                <Box>
                    <Field
                        name="rgpd"
                        label={() => (
                            <div>
                                J’ai lu et accepte la &nbsp;
                                <a href="/mentions-legales/" target="blank">
                                    politique de protection des données
                                    personnelles
                                </a>
                                &nbsp; de Patrimoine-Environnement *
                            </div>
                        )}
                        id="rgpd"
                        component={RFCheckbox}
                        type="checkbox"
                        required
                    />
                </Box>
                <Box>
                    {error && <FormHelperText error>{error}</FormHelperText>}
                    {errors &&
                        errors.length > 0 &&
                        errors.map(item => (
                            <FormHelperText error>{item}</FormHelperText>
                        ))}
                    {created && (
                        <Typography variant=" " className={classes.success}>
                            {created}
                        </Typography>
                    )}
                </Box>
                <div>
                    <Button
                        type="button"
                        onClick={previousPage}
                        className={"form__previousButton"}
                    >
                        Précédent
                    </Button>
                    <Button
                        variant="contained"
                        type="submit"
                        data-testid="submit"
                        className="form__button"
                        disabled={!valid}
                    >
                        {loading ? (
                            <CircularProgress color="#fff" />
                        ) : (
                            "Envoyer"
                        )}
                    </Button>
                </div>
            </form>
        </>
    );
};
const mapStateToProps = state => ({
    regions: state.types.regions,
    natureTypes: state.types.natureTypes,
    networkTypes: state.types.networkTypes,
    structureTypes: state.types.structureTypes,
    errors: state.form.event.submitErrors,
    error: state.formCustom.error,
    valid: state.formCustom.valid,
    loading: state.formCustom.loading,
    created: state.formCustom.created,
    dataLoading: state.types.loading,
    dataError: state.types.error,
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps),
    reduxForm({
        form: "event",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate,
    })
)(ThirdPage);
